module.exports = __webpack_public_path__ + "static/media/disfraz-niña.cdb9faa3.jpg";